/* @ngInject */
const mainMenu = (
  $state,
  labels,
  routes,
  authService
) => {
  const self = [{
    title: labels.menus.consult,
    isActive: false,
    ref: routes.consult.index.path,
    display: () => true,
    go: () => {
      this.isActive = true
      $state.go(routes.consult.index.path)
    },
  }, {
    title: labels.menus.maneuver,
    isActive: false,
    ref: routes.maneuver.index.path,
    display: () => true,
    go: () => {
      this.isActive = true
      $state.go(routes.maneuver.index.path)
    },
  }, {
    title: labels.menus.scrap,
    isActive: false,
    ref: routes.scrapping.index.path,
    display: () => true,
    go: () => {
      this.isActive = true
      $state.go(routes.scrapping.index.path)
    },
  }, {
    title: labels.menus.invoice,
    isActive: false,
    ref: routes.invoicing.index.path,
    display: () => authService.isAdmin(),
    go: () => {
      this.isActive = true
      $state.go(routes.invoicing.index.path)
    },
  },]

  return self
}

export default mainMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/menus/main.menu.js